"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubNativeAuthClient = void 0;
const axios_1 = __importDefault(require("axios"));
const hub_1 = require("../../../hub");
const IBaseApiConstructor_1 = require("../../models/IBaseApiConstructor");
const host_1 = require("../../utils/host");
class BaseAuthClient {
    httpClient;
    accessKey;
    constructor({ token = '', env = '', timeout = IBaseApiConstructor_1.BaseTimeout, }) {
        this.httpClient = axios_1.default.create({
            baseURL: (0, host_1.getApiHost)(hub_1.AppName.HUB, env),
            timeout,
        });
        this.accessKey = token;
    }
    async request(method, loginWith, tokenRequestId) {
        const params = new URLSearchParams([[loginWith, tokenRequestId]]);
        const request = {
            url: '/auth/token',
            method,
            params: params,
            headers: {
                Accept: 'application/json',
                Authorization: `Basic ${this.accessKey}`,
            },
        };
        const response = await this.httpClient.request(request);
        return response?.data?.data;
    }
}
class HubNativeAuthClient extends BaseAuthClient {
    async getToken(loginWith, tokenRequestId) {
        return await this.request('GET', loginWith, tokenRequestId);
    }
}
exports.HubNativeAuthClient = HubNativeAuthClient;
